import React, { useEffect, useState, useContext } from "react";
import { Controller, useForm } from "react-hook-form";
import { useSelector, useDispatch } from "react-redux";
import * as _ from "lodash";
import moment from "moment/moment";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { MDBCol, MDBRow } from "mdbreact";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import DeleteIcon from "@mui/icons-material/Delete";
import { Box, IconButton, Tooltip } from "@mui/material";
import { Download } from "@mui/icons-material";
import "./Verification.scss";
import { Button, COLORS, GenericDropdown, Input, Label, Modal, Switch, AbsDropDown, RadioInput } from "abs-ui-components";
import AbsModal from "../../../common/absModal/AbsModal";
import Loader from "../../../common/Loader/Loader";
import CustomTable from "../../../common/customTable/CustomTable";
import VerificationSelectFiles from "./VerificationSelectFiles";
import { accessAPIForResponse } from "../../../services/api-services/api-implementations";
import axiosHttp from "../../../services/interceptor";
import { emitToasterMsg } from "../../../services/toasterUtility";
import { reportsActions } from "../../../store/reports/reports.slice";
import AutocompleteDropdown from "../../../common/autocompleteDropdown/AutocompleteDropdown";
import { ClaimsContext } from "../../../services/ClaimsService";
import { ClaimType } from "../../../constants/claims";
import { DATE_FORMAT_DD_MMM_YYYY } from "../../../constants/dateFormats";
import { FeatureType } from "../../../constants/FeatureToggles";
import { CII_UNSATISFACTORY_WARNING_MESSAGES } from "../../../constants/CIIUnsatisfactoryConstants";

const Verification = ({selectedWaypointVersion, setSelectedWaypointVersion}) => {
	const { userHasClaim, userHasFeature, userFeaturesAreLoaded } = useContext(ClaimsContext);
	const [verifierOptions, setVerifierOptions] = useState([]);
	const [selectedVerifier, setSelectedVerifier] = useState();
	const [selectedVerifyDate, setSelectedVerifyDate] = useState(null);
	const [selectedVerifyMoment, setSelectedVerifyMoment] = useState(null);
	const [isSelectFilesModalOpen, setIsSelectFilesModalOpen] = useState(false);
	const [selectedFiles, setSelectedFiles] = useState([]);
	const [associatedDocumentsData, setAssociatedDocumentsData] = useState([]);
	const [loader, setLoader] = useState(false);
	const [showModal, setShowModal] = useState(false);
	const [confirmDelete, setConfirmDelete] = useState(false);
	const [selectedDocument, setSelectedDocument] = useState(null);
	const [reportFlags, setReportFlags] = useState(null);
	const [refreshKey, setRefreshKey] = useState(0);
	const [verificationEnabled, setVerificationEnabled] = useState(false); // Fixed typo: SetverificationEnabled to setVerificationEnabled
	const [isReportFlagsLoaded, setIsReportFlagsLoaded] = useState(false); // New state to track completion
	const [showUpdateVerifierModal, setShowUpdateVerifierModal] = useState(false);
	const [templateType, setTemplateType] = useState("");
	const user = useSelector((state) => state.userInfo.userData);
	const [selectedGisisVersion, setSelectedGisisVersion] = useState("Fuel20231");
	const [submissionStatus, setSubmissionStatus] = useState("");
	const [submitDateTime, setSubmitDateTime] = useState("");
	const [reportTypeDisplay, setReportTypeDisplay] = useState("");
	//waypoint states
	const [waypointSubmissionStatus, setWaypointSubmissionStatus] = useState("");
	const [waypointStatusMessage, setWaypointStatusMessage] = useState("");
	const [waypointSubmitDateTime, setWaypointSubmitDateTime] = useState("");
	const [waypointReportTypeDisplay, setWaypointReportTypeDisplay] = useState("");

	const [loading, setLoading] = useState(false);
	const [isGisisSubmitEnabled, setisGisisSubmitEnabled] = useState(false);
	const [isWaypointSubmissionEnabled, setIsWaypointSubmissionEnabled] = useState(false);
	const [options, setOptions] = useState([]);
	const {
		control,
		handleSubmit,
		formState: { errors },
		reset,
	} = useForm();
	useEffect(() => {
		var gisisSubmitEnabled = userFeaturesAreLoaded && userHasFeature(FeatureType.GisisSubmitVerification);
		setisGisisSubmitEnabled(gisisSubmitEnabled);
	}, [userFeaturesAreLoaded, userHasFeature]);
	const onSelectFilesEvent = () => {
		setIsSelectFilesModalOpen(!isSelectFilesModalOpen);
		if (isSelectFilesModalOpen) {
			setSelectedFiles([]);
		}
	};
	useEffect(() => {
		var waypointSubmitEnabled = userFeaturesAreLoaded && userHasFeature(FeatureType.WayPointSubmitVerification);
		setIsWaypointSubmissionEnabled(waypointSubmitEnabled);
	}, [userFeaturesAreLoaded, userHasFeature]);

	const [iswayPointMessageModalOpen, setIsWayPointMessageModalOpen] = useState(false);
    const [wayPointErrorMessage, setwayPointErrorMessage] = useState("");

	const reportDetails = useSelector((state) => state.reports.selectedReportDetails);
	const reportingYear = reportDetails?.ReportYear;

	const dispatch = useDispatch();

	const fetchReportDetails = async (reportMasterId) => {
		await accessAPIForResponse("GetReportDetailsByReportId", null, [reportMasterId]).then((response) => {
			if (response) {
				dispatch(
					reportsActions.setSelectedReportDetails({
						selectedReportDetails: response,
					})
				);
			}
		});
	};

	useEffect(() => {
		const fetchInitialHistory = async () => {
			if (!reportDetails?.ReportMstId) return;

			try {
				setLoading(true);
				const response = await axiosHttp.get(
					`/api/ImoDcs/gisis-last-history/${encodeURIComponent(reportDetails.ReportMstId)}?gisisVersion=${encodeURIComponent(selectedGisisVersion)}`
				);

				const data = response?.data;

				if (data) {
					setSubmissionStatus(data.status);
					setSubmitDateTime(moment.utc(data.submittedOn).isValid() ? moment.utc(data.submittedOn).format("DD-MMM-YYYY HH:mm") + " UTC" : "");
					setReportTypeDisplay(data.gisisVersion === "Fuel20231" ? "2024-2025 Report Granularity" : "2025-2026 Report Granularity");
					setSelectedGisisVersion(data.gisisVersion);
				} else {
					setSubmissionStatus("");
					setSubmitDateTime("");
					setReportTypeDisplay("");
				}
			} catch (error) {
				setSubmissionStatus("");
				setSubmitDateTime("");
				setReportTypeDisplay("");
			} finally {
				setLoading(false);
			}
		};

		reportFlags?.Regulations==="DCS" && fetchInitialHistory();
	}, [selectedGisisVersion, isReportFlagsLoaded]);

	useEffect(() => {
		const fetchInitialwaypointHistory = async () => {
			if (!reportDetails?.ReportMstId) return;

			try {
				setLoading(true);
				const response = await axiosHttp.get(
					`/api/ImoDcs/waypoint-last-history/${encodeURIComponent(reportDetails.ReportMstId)}`
				);

				const data = response?.data;

				if (data) {
					setWaypointSubmissionStatus(data.status);
					setWaypointSubmitDateTime(moment.utc(data.submittedOn).isValid() ? moment.utc(data.submittedOn).format("DD-MMM-YYYY HH:mm") + " UTC" : "");
					setWaypointReportTypeDisplay(data.waypointVersion === "Fuel2025" ? "2025 Schema" : "2023 Schema");
					setSelectedWaypointVersion(data.waypointVersion);
					if (data.status === "Failed") {
						setWaypointStatusMessage(data.statusMessage || "Submission failed");
					} else {
						setWaypointStatusMessage("");
					}
				} else {
					setWaypointSubmissionStatus("");
					setWaypointSubmitDateTime("");
					setWaypointReportTypeDisplay("");
					setWaypointStatusMessage("");
				}
			} catch (error) {
				setWaypointSubmissionStatus("");
				setWaypointSubmitDateTime("");
				setWaypointReportTypeDisplay("");
				setWaypointStatusMessage("");
			} finally {
				setLoading(false);
			}
		};

		reportFlags?.Regulations==="DCS" && fetchInitialwaypointHistory();
	}, [isReportFlagsLoaded]);

	useEffect(() => {
		let updatedOptions = [];
		if (reportFlags?.Regulations === "DCS") {
			updatedOptions = [
				{ value: "Review Letter", label: "Review Letter" },
				{ value: "SOC", label: "SOC" },
			];
		} else if (["EUMRV", "UKMRV", "FEU","UKETS"].includes(reportFlags?.Regulations)) {
			updatedOptions = [{ value: "Review Letter", label: "Review Letter" }];
		}
		setOptions(updatedOptions);

		if (updatedOptions.length > 0) {
			setTemplateType(updatedOptions[0].value);
		} else {
			setTemplateType("");
		}
	}, [reportFlags?.Regulations]);

	const onChangeRegulation = (regulationKey) => {
		setSelectedGisisVersion(regulationKey);
	};

	const onChangeRegulationwaypoint = (regulationKey) => {
		setSelectedWaypointVersion(regulationKey);
	};
	useEffect(() => {
		if (reportingYear) {
			setSelectedWaypointVersion("Fuel2025");
		}
	}, [reportingYear]);

	const onVerifierChange = (selected) => {
		setSelectedVerifier(selected?.value);
	};

	const onTemplateOptionChange = (selectedOption) => {
		setTemplateType(selectedOption[0]);
	};

	const VerificationColumns = [
		{
			header: "Published Documents",
			accessorKey: "documentFileName",
		},
		{
			header: "Revision Number",
			accessorKey: "revisionNumber",
		},

		{
			header: "To be made available to Client?",
			accessorKey: "isAvailableForClient",
			hidden: !userHasClaim(ClaimType.AVAILABLE_FOR_CLIENT_CHECK),
			enableSorting: false,
			enableColumnActions: false,
			enableColumnFilters: false,
			muiTableHeadCellProps: {
				align: "center",
			},
			muiTableBodyCellProps: {
				align: "center",
			},
			muiTableFooterCellProps: {
				align: "center",
			},
			Cell: ({ row: { original } }) => {
				const [selected, setSelected] = useState(original.isAvailableForClient === true ? "Yes" : "No");
				const handleChange = (link) => {
					setSelected(link);
					handleAvailableForClient(link, original.documentMstId);
				};
				return <Switch links={["Yes", "No"]} selected={selected} onChange={(link) => handleChange(link)} />;
			},
		},

		{
			header: "Action",
			accessorKey: "action",
			enableSorting: false,
			enableColumnActions: false,
			enableColumnFilters: false,
			muiTableHeadCellProps: {
				align: "center",
			},
			muiTableBodyCellProps: {
				align: "center",
			},
			muiTableFooterCellProps: {
				align: "center",
			},
			Cell: ({ row: { original } }) => (
				<>
					<Box sx={{ display: "flex", gap: "1rem" }}>
						<Tooltip title="Download">
							<IconButton
								color="info"
								onClick={(e) => {
									e.stopPropagation();
									handleDownload(original.documentMstId, original.documentFileName);
								}}
							>
								<Download sx={{ color: "#0645AD" }} />
							</IconButton>
						</Tooltip>
					</Box>
					<Box sx={{ display: "flex", gap: "1rem" }}>
						<Tooltip title="Delete">
							<IconButton
								color="error"
								onClick={(e) => {
									e.stopPropagation();
									handleDeleteBtnClick(original, true);
								}}
							>
								<DeleteIcon />
							</IconButton>
						</Tooltip>
					</Box>
				</>
			),
		},
	];

	useEffect(() => {
		if (reportDetails?.ReportMstId) {
			fetchReportDetails(reportDetails.ReportMstId); // Added fetchReportDetails call
			getReportFlags();
		}
	}, [refreshKey, reportDetails?.ReportMstId]);

	const getReportFlags = async () => {
		try {
			setLoader(true);
			const response = await accessAPIForResponse("GetReportFlags", null, [reportDetails?.ReportMstId]);

			setReportFlags(response);
			setIsReportFlagsLoaded(true); // Set the flag to true when data is loaded
		} catch (error) {
			console.error(error);
		} finally {
			setLoader(false);
		}
	};

	const handleRefresh = () => {
		setRefreshKey((prevKey) => prevKey + 1);
	};

	useEffect(() => {
		if (isReportFlagsLoaded) {
			GetVerifyEngineersList();
			GetAssociatedDocuments();
		}
	}, [isReportFlagsLoaded]);

	const GetAssociatedDocuments = async () => {
		await accessAPIForResponse("GetAssociatedDocuments", null, [reportDetails?.ReportMstId]).then((response) => {
			if (response && response.isSuccess) {
				const responseData = response?.data;
				transformData(responseData);
			}
		});
	};

	const transformData = (data) => {
		let assignedDocsData = [];
		data.forEach((element) => {
			element.IsAvailableForClient = element.IsAvailableForClient === false ? "No" : "Yes";
			assignedDocsData.push(element);
		});
		setAssociatedDocumentsData(data);
	};
	const GetVerifyEngineersList = async (input) => {
		try {
			const response = await accessAPIForResponse("GetVerifyEngineers", null, [input]);
			if (response && response.isSuccess) {
				const verifier_options = response.data.map((obj, index) => ({
					label: obj.emailAddress,
					value: obj.emailAddress,
					id: index + 1,
				}));

				if (reportFlags && reportFlags?.Verifier?.trim()) {
					setSelectedVerifier(reportFlags?.Verifier);
				}

				return verifier_options;
			}
			return [];
		} catch (error) {
			console.error("Error fetching verify engineers:", error);
			return [];
		}
	};

	useEffect(() => {
		if (reportFlags?.VerificationCompleteDate) {
			const parsed = moment(reportFlags.VerificationCompleteDate, [DATE_FORMAT_DD_MMM_YYYY, "YYYY-MM-DD", "YYYY-MM-DDTHH:mm:ss"]);
			if (parsed.isValid()) {
				setSelectedVerifyMoment(parsed);
				setSelectedVerifyDate(parsed.format(DATE_FORMAT_DD_MMM_YYYY));
			}
		}
	}, [reportFlags?.VerificationCompleteDate]);

	const handleChangeDate = (value) => {
		if (!value || !value.isValid || !value.isValid()) {
			setSelectedVerifyMoment(null);
			setSelectedVerifyDate(null);
			return;
		}
		setVerificationEnabled(true);
		setSelectedVerifyMoment(value);
		const formatted = value.format(DATE_FORMAT_DD_MMM_YYYY);
		setSelectedVerifyDate(formatted);
	};

	const onVerificationComplete = () => {
		if (reportDetails?.ReportMstId && selectedVerifyDate) {
			axiosHttp
				.post(
					`api/Verification/VerificationComplete?reportMstId=${reportDetails?.ReportMstId}&verificationDate=${encodeURIComponent(selectedVerifyDate)}`
				)
				.then((response) => {
					if (response?.data?.isSuccess) {
						handleRefresh();
						emitToasterMsg("success", "Verification Completed Successfully");
						dispatch(reportsActions.setVerificationStatus(true));
					}
				});
		} else {
			emitToasterMsg("error", "Please select verification complete date");
		}
	};

	const onSubmitToVerifier = () => {
		if (reportDetails?.ReportMstId && selectedVerifier && selectedVerifier !== "0") {
			axiosHttp.post(`api/Verification/AssignVerifier?reportMstId=${reportDetails?.ReportMstId}&userEmail=${selectedVerifier}`).then((response) => {
				if (response?.data && response?.data?.isSuccess) {
					handleRefresh();
					emitToasterMsg("success", "Submitted to Verifier Successfully");
					dispatch(reportsActions.setVerificationStatus(true));
				}
			});
		} else {
			emitToasterMsg("error", "Please select verifier");
		}
	};

	const changeVerifierForReport = () => {
		if (reportDetails?.ReportMstId && selectedVerifier && selectedVerifier !== "0") {
			axiosHttp.post(`/api/Verification/AssignVerifier?reportMstId=${reportDetails?.ReportMstId}&userEmail=${selectedVerifier}`).then((response) => {
				if (response && response?.data?.isSuccess) {
					handleRefresh();
					emitToasterMsg("success", "Verifier Updated Successfully");
					setShowUpdateVerifierModal(false);
				}
			});
		} else {
			emitToasterMsg("error", "Please select verifier");
		}
	};

	const onRejectReport = (formData) => {
		const requestPayload = {
			reportMstId: reportDetails?.ReportMstId,
			remarks: formData?.reason,
		};
		axiosHttp.post(`/api/Verification/RejectVerification`, requestPayload).then((response) => {
			if (response && response?.data?.isSuccess) {
				toggleClose();
				handleRefresh();
				emitToasterMsg("success", "Report rejected");
				dispatch(reportsActions.setVerificationStatus(true));
			}
		});
	};

	const uploadDocuments = (files) => {
		const formData = new FormData();
		files.forEach((file) => {
			formData.append("documentFiles", file);
		});
		formData.append("ReportMstId", reportDetails?.ParentReportMstId);
		formData.append("ChildReportMstIds", `${reportDetails?.ReportMstId}`);
		formData.append("IsVerification", "Y");

		setLoader(true);

		axiosHttp
			.post(`api/Documents/UploadDocuments`, formData, {
				headers: {
					"Content-Type": "multipart/form-data",
				},
			})
			.then((response) => {
				if (response?.data?.isSuccess === false) {
					const errorMessage = response?.data?.errorMessage || "An error occurred while uploading documents.";
					emitToasterMsg("error", errorMessage);
				} else {
					emitToasterMsg("success", "Files uploaded successfully");
					GetAssociatedDocuments();
					toggleClose();
				}
				setLoader(false);
			})
			.catch((error) => {
				setLoader(false);
				console.error(error);
			});
	};

	const handleUploadClick = () => {
		uploadDocuments(selectedFiles);
		setSelectedFiles([]);
	};

	const handleDownloadForEdit = () => {
		setLoader(true);
		axiosHttp
			.get(`api/Verification/DownloadTemplate?templateType=${templateType}&reportMstId=${reportDetails?.ReportMstId}`, {
				responseType: "blob",
			})
			.then((response) => {
				if (response?.data?.type !== "application/json") {
					const url = window.URL.createObjectURL(new Blob([response?.data]));
					const link = document.createElement("a");
					link.href = url;
					templateType === templateType &&
						link.setAttribute("download", templateType === "Review Letter" ? templateType + ".docx" : templateType + ".pdf");

					document.body.appendChild(link);
					link.click();
					setLoader(false);
					emitToasterMsg("success", "Template downloaded successfully.");
				} else {
					setLoader(false);
					emitToasterMsg("error", "Report status is not valid to generate the template");
				}
			})
			.catch((error) => {
				setLoader(false);
				console.error(error);
			});
	};

	const uploadForPublishing = () => {
		setLoader(true);
		axiosHttp
			.get(`api/Verification/TemplateDocumentToPublish?templateType=${templateType}&reportMstId=${reportDetails?.ReportMstId}`)
			.then((response) => {
				const reponseData = response?.data;
				if (reponseData && reponseData?.isSuccess) {
					GetAssociatedDocuments();
					emitToasterMsg("success", reponseData?.data);
				} else if (reponseData && !reponseData?.isSuccess) {
					emitToasterMsg("error", reponseData?.errorMessage);
				}
				setLoader(false);
			})
			.catch((error) => {
				setLoader(false);
				console.error(error);
			});
	};

	const handleAvailableForClient = async (link, DocumentMstId) => {
		const requestPayload = {
			documentMstId: DocumentMstId,
			reportMstId: reportDetails?.ReportMstId,
			isAssociate: link === "Yes" ? true : false,
		};
		await accessAPIForResponse("SetAvailableToClient", requestPayload, []).then((response) => {
			if (response && response.isSuccess) {
			}
		});
	};

	const handleGisisSubmit = async () => {
		if (!selectedGisisVersion || !reportDetails?.ReportMstId) return;

		setLoading(true);
		try {
			// Prepare the query string
			const requestParams = `gisisVersion=${encodeURIComponent(selectedGisisVersion)}`;
			// Define the API endpoint with ReportMstId in the path
			const API = `/api/ImoDcs/send-gisis/${encodeURIComponent(reportDetails?.ReportMstId)}`;
			const response = await axiosHttp.get(`${API}?${requestParams}`);

			// Handle HTTP 200 OK
			if (response.status === 200) {
				const { status, submittedOn, gisisVersion } = response?.data;

				const formattedDate = moment.utc(submittedOn).isValid() ? moment.utc(submittedOn).format("DD-MMM-YYYY HH:mm") + " UTC" : "";
				setSubmitDateTime(formattedDate);
				setReportTypeDisplay(gisisVersion === "Fuel20231" ? "2024-2025 Report Granularity" : "2025-2026 Report Granularity");
				setSubmissionStatus(status);
				if (status === "Successful") {
					emitToasterMsg("success", "Submitted to GISIS successfully");
				} else if (status === "Failed") {
					emitToasterMsg("error", "GISIS submission failed");
				} else {
					emitToasterMsg("error", `Internal ERP Error: ${response?.data.statusMessage}`);
				}
			} else {
				// Handle unexpected status codes (200)
				setSubmissionStatus("ERP Error");
				emitToasterMsg("error", `Internal ERP Error: ${response?.data.statusMessage}`);
			}
		} catch (error) {
			//Handle HTTP 500 Internal Server Error and other errors
			setSubmissionStatus("");
			setSubmitDateTime("");
			setReportTypeDisplay("");
			emitToasterMsg("error", `Error: ${error.response?.data.message}`);
		} finally {
			setLoading(false);
		}
	};

	const handleWaypointSubmit = async () => {
		if (!selectedWaypointVersion || !reportDetails?.ReportMstId) return;

		setLoading(true);
		try {
			// Prepare the query string
			const requestParams = `waypointVersion=${encodeURIComponent(selectedWaypointVersion)}`;
			// Define the API endpoint with ReportMstId in the path
			const API = `/api/ImoDcs/send-waypoint/${encodeURIComponent(reportDetails?.ReportMstId)}`;
			const response = await axiosHttp.get(`${API}?${requestParams}`);

			// Handle HTTP 200 OK
			if (response.status === 200) {
				const { status, submittedOn, waypointVersion, statusMessage } = response?.data;

				const formattedDate = moment.utc(submittedOn).isValid() ? moment.utc(submittedOn).format("DD-MMM-YYYY HH:mm") + " UTC" : "";
				setWaypointSubmitDateTime(formattedDate);
				setWaypointReportTypeDisplay(waypointVersion === "Fuel2023" ? "2023 Schema" : "2025 Schema");
				setWaypointSubmissionStatus(status);
				if (status === "Successful") {
					setWaypointStatusMessage("");
					emitToasterMsg("success", "Submitted to Waypoint successfully");
				} else if (status === "Failed") {
					setWaypointStatusMessage(statusMessage || "Submission failed");
					emitToasterMsg("error", "Waypoint submission failed");
				} else {
					setWaypointStatusMessage(statusMessage || "");
					emitToasterMsg("error", `Internal ERP Error: ${statusMessage}`);
				}
			} else {
				// Handle unexpected status codes (200)
				setWaypointSubmissionStatus("ERP Error");
				emitToasterMsg("error", `Internal ERP Error: ${response?.data.statusMessage}`);
			}
		} catch (error) {
			//Handle HTTP 500 Internal Server Error and other errors
			setWaypointSubmissionStatus("");
			setWaypointSubmitDateTime("");
			setWaypointReportTypeDisplay("");
			emitToasterMsg("error", `Error: ${error.response?.data.message}`);
		} finally {
			setLoading(false);
		}
	};

	const handleDownload = (documentId, documentName) => {
		setLoader(true);
		axiosHttp
			.get(`api/Documents/DownloadDocument?documentMstId=${documentId}`, {
				responseType: "blob",
			})
			.then((response) => {
				const url = window.URL.createObjectURL(new Blob([response.data]));
				const link = document.createElement("a");
				link.href = url;
				link.setAttribute("download", documentName);
				document.body.appendChild(link);
				link.click();
				setLoader(false);
				emitToasterMsg("success", "Document downloaded successfully.");
			})
			.catch((error) => {
				setLoader(false);
				console.error(error);
			});
	};

	const handleModal = () => {
		if (reportDetails?.ReportMstId) {
			setShowModal(true);
		}
	};

	const handleUpdateVerifierModal = () => {
		if (reportDetails?.ReportMstId && selectedVerifier && selectedVerifier !== "0") {
			setShowUpdateVerifierModal(true);
		} else {
			emitToasterMsg("error", "Please select verifier");
		}
	};

	const toggleClose = () => {
		setShowModal(false);
	};

	const handleDeleteBtnClick = (row) => {
		setConfirmDelete(true);
		setSelectedDocument(row);
	};

	const handleDeletingRecord = () => {
		axiosHttp({
			url: `api/Verification/DeleteVerificationDocuments?documentMstId=${selectedDocument.documentMstId}`,
			method: "delete",
		})
			.then((res) => {
				setConfirmDelete(false);
				if (res && res?.data?.isSuccess) {
					GetAssociatedDocuments();
					emitToasterMsg("success", "Deleted Successfully");
				} else if (!res?.data?.isSuccess) {
					emitToasterMsg("error", res?.data?.errorCode);
				}
			})
			.catch((error) => {
				setConfirmDelete(false);
				console.error(error.response.data.errorMessage);
			});
	};

	return (
		<>
			{loader && <Loader />}
			{reportDetails?.ShouldShowUnsatisfactoryWarning && (
				<div className = "unsatifactory-warning-msg" style={{marginTop:"-10px"}}>
					{CII_UNSATISFACTORY_WARNING_MESSAGES.VERIFICATION_UNSATISFACTORY_WARNING}
				</div>
			)}
			<MDBRow className="mt-4">
				<MDBCol md={reportDetails?.Regulations !== "DCS" && "4"}>
					<div className="verification-container">
						<div
							className={`my-div  ${reportDetails.ReportStatus === "Verification Completed" || reportDetails.reviewer === "" ? "disabled" : ""}`}
						>
							{reportFlags?.RejectionInfo?.Name && (
								<div>
									<MDBRow className="d-flex justify-content-between mb-4">
										<MDBCol md="3">
											<Label className="label-text" name="Rejected by :" />
										</MDBCol>
										<MDBCol md="9">{reportFlags?.RejectionInfo?.Name}</MDBCol>
									</MDBRow>
									<MDBRow className="d-flex justify-content-between mb-4">
										<MDBCol md="3">
											<Label className="label-text" name="Remarks :" />
										</MDBCol>
										<MDBCol md="9">{reportFlags?.RejectionInfo?.Reason}</MDBCol>
									</MDBRow>
								</div>
							)}
							<MDBRow className="d-flex mb-4">
								<MDBCol md="3">
									<Label name="Verifier :" bold />
								</MDBCol>
								<MDBCol md="5" className="verifier-dropdown">
									<div>
										<AutocompleteDropdown
											className="inputHeight"
											id="search-vessel-id"
											isClearable
											loadOptions={async (inputText) => {
												const options = await GetVerifyEngineersList(inputText);
												return options;
											}}
											placeholder={selectedVerifier || "Please Select Verifier"}
											onChange={onVerifierChange}
											autoFocus={false}
											customStyles={{
												menuList: (provided) => ({
													...provided,
												}),
											}}
										/>
									</div>
								</MDBCol>
								<MDBCol md="3">
									{reportFlags?.IsUpdateVerifierEnabled && <Button onClick={() => handleUpdateVerifierModal()}>Update</Button>}

									{reportFlags?.IsSubmitToVerifierEnabled && (
										<Button disabled={false} onClick={() => onSubmitToVerifier()}>
											Submit to Verifier
										</Button>
									)}
								</MDBCol>
							</MDBRow>

							<MDBRow className="date-picker-dropdown mt-4">
								<MDBCol md="3" className="d-flex">
									<Label name="Verification Complete Date :" bold />
								</MDBCol>
								<MDBCol>
									<LocalizationProvider
										dateAdapter={AdapterMoment}
										className="verification-datePicker"
										localeText={{ fieldMonthPlaceholder: (params) => (params.contentType === "digit" ? "MM" : params.format) }}
									>
										<DatePicker
											value={selectedVerifyMoment}
											onChange={handleChangeDate}
											format={
												reportFlags?.VerificationCompleteDate?.trim() ? reportFlags.VerificationCompleteDate : DATE_FORMAT_DD_MMM_YYYY
											}
											sx={{
												".MuiInputBase-root": {
													height: "35px",
													width: "98%",
												},
											}}
										/>
									</LocalizationProvider>
								</MDBCol>
							</MDBRow>

							<MDBRow className="mt-4 status-btn">
								<MDBCol className="col-8 d-flex justify-content-end">
									<Button
										disabled={reportFlags?.IsVerificationCompleteEnabled && verificationEnabled ? false : true}
										onClick={onVerificationComplete}
										primaryBackgroundColor="#DC1E34"
										primaryColor="#DC1E34"
									>
										Verification Complete
									</Button>

									{reportFlags?.IsRejectReportEnabled && (
										<Button
											className="reject-btn ml-4"
											primaryBackgroundColor={COLORS.RED.DARK}
											primaryColor={COLORS.RED.DARK}
											disabled={!verificationEnabled}
											onClick={handleModal}
										>
											Reject
										</Button>
									)}
								</MDBCol>
							</MDBRow>
						</div>
					</div>
				</MDBCol>

				<MDBCol md={reportDetails?.Regulations !== "DCS" && "5"} className="verification-template-container mt-4">
					<div className="verification-template">
						<MDBRow className="d-flex justify-content-between mb-4">
							<MDBCol md="2">
								<Label name="Template Generator :" className="mt-2" bold />
							</MDBCol>
							<MDBCol md="3" className="review-dropdown">
								<GenericDropdown options={options} selected={templateType} handleChange={onTemplateOptionChange} />
							</MDBCol>
							<div className="d-flex ml-3 download-btn-container">
								<div>
									<Button disabled={false} onClick={handleDownloadForEdit}>
										Download for edit
									</Button>
								</div>
								<div className="ml-3">
									<Button disabled={false} onClick={uploadForPublishing} variant="secondary">
										Upload for publishing
									</Button>
								</div>
							</div>
							<MDBCol md=""></MDBCol>
							<MDBCol></MDBCol>
						</MDBRow>
						<MDBRow className="d-flex justify-content-between document-type">
							<MDBCol md="2">
								<Label name="New Document Type :" className="mt-2" bold />
							</MDBCol>
							<MDBCol>
								<Button disabled={false} variant="secondary" className="ml-1" onClick={onSelectFilesEvent}>
									Select Files
								</Button>
							</MDBCol>
						</MDBRow>
					</div>
				</MDBCol>
				{/* GISIS Submission Section, will be visible for DCS child report when the country flag is not set to Liberia*/}
				{reportDetails?.Regulations === "DCS" && isGisisSubmitEnabled && reportDetails?.VesselMst?.PortCodeMst?.CountryCode !== "LR" && (
					<MDBCol md="3">
						<div style={{ borderLeft: "1px solid #8a8a8a", paddingLeft: "24px", paddingBottom: "20px" }}>
							{loading && <Loader />}

							<h6>
								<strong>GISIS Submission</strong>
							</h6>

							{/* Radio buttons inline */}
							<div className="mt-3 d-flex gisis-radio-btn ">
								<RadioInput
									label="2024-2025 Report Granularity"
									gap="true"
									checked={selectedGisisVersion === "Fuel20231"}
									onChange={() => {
										onChangeRegulation("Fuel20231");
									}}
								/>
								<div className="ml-3">
									<RadioInput
										label="2025-2026 Report Granularity"
										className="pl-2"
										gap="true"
										checked={selectedGisisVersion === "Fuel20251"}
										onChange={() => {
											onChangeRegulation("Fuel20251");
										}}
									/>
								</div>
							</div>

							<div className="mt-5">
								<Button
									disabled={!["Verification Completed", "Verification In Progress"].includes(reportDetails.ReportStatus)}
									primaryBackgroundColor="#DC1E34"
									primaryColor="#DC1E34"
									onClick={handleGisisSubmit}
								>
									Submit to GISIS
								</Button>
							</div>

							<div className="mt-3">
								<div className="d-flex">
									<Label name="Submission Status:" bold />
									<small
										className="ml-2"
										style={{
											color: submissionStatus === "Failed" || submissionStatus === "ERP Error" ? "red" : "inherit",
										}}
									>
										{submissionStatus}
									</small>{" "}
								</div>
								<div className="d-flex">
									<Label name="Submit Date/Time:" className="mt-2" bold />
									<small className="ml-2 mt-2">{submitDateTime}</small>
								</div>
								<div className="d-flex">
									<Label name="Report:" className="mt-2" bold />
									<small className="ml-2 mt-2">{reportTypeDisplay}</small>
								</div>
							</div>
						</div>
					</MDBCol>
				)}

				{/* Waypoint Submission Section, will be visible for DCS child report when the country flag is Liberia*/}
				{reportDetails?.Regulations === "DCS" && isWaypointSubmissionEnabled && reportDetails?.VesselMst?.PortCodeMst?.CountryCode === "LR" && (
					<MDBCol md="3">
						<div style={{ borderLeft: "1px solid #8a8a8a", paddingLeft: "24px", paddingBottom: "20px" }}>
							{loading && <Loader />}

							<h6>
								<strong>WayPoint Submission</strong>
							</h6>

							{/* Radio buttons inline */}
							<div className="mt-3 d-flex gisis-radio-btn ">
								<RadioInput
									label="2023 Schema"
									gap="true"
									checked={selectedWaypointVersion === "Fuel2023"}
									onChange={() => {
										onChangeRegulationwaypoint("Fuel2023");
									}}
								/>
								<div className="ml-3">
									<RadioInput
										label="2025 Schema"
										className="pl-2"
										gap="true"
										checked={selectedWaypointVersion === "Fuel2025"}
										onChange={() => {
											onChangeRegulationwaypoint("Fuel2025");
										}}
									/>
								</div>
							</div>

							<div className="mt-5 d-flex">
								<Button
									disabled={!["Verification Completed", "Verification In Progress"].includes(reportDetails.ReportStatus)}
									primaryBackgroundColor="#DC1E34"
									primaryColor="#DC1E34"
									onClick={handleWaypointSubmit}
								>
									Submit to WayPoint
								</Button>

							</div>

							<div className="mt-3">
								<div className="d-flex">
									<Label name="Submission Status:" bold />
									<small
										className="ml-2"
										style={{
											color: waypointSubmissionStatus === "Failed" || waypointSubmissionStatus === "ERP Error" ? "red" : "inherit",
										}}
									>
										{waypointSubmissionStatus}
									</small>
								</div>

								<div className="d-flex">
									<Label name="Submitted Date & Time:" className="mt-2" bold />
									<small className="ml-2 mt-2">{waypointSubmitDateTime}</small>
								</div>
								<div className="d-flex">
									<Label name="Submitted Schema:" className="mt-2" bold />
									<small className="ml-2 mt-2">{waypointReportTypeDisplay}</small>
								</div>
								{waypointSubmissionStatus === "Failed" && waypointStatusMessage && (
									<div className="d-flex">
										<Label name="Reason for Failure:" className="mt-2" bold />

										{waypointStatusMessage.length > 50 ? (
											<small
												className="ml-2 mt-2"
												style={{ color: "red" }}
												
											>
												{waypointStatusMessage.slice(0, 50)}...{" "}
												<span style={{ textDecoration: "underline", color: "#02162b",cursor:"pointer" }}
													onClick={() => {
														setwayPointErrorMessage(waypointStatusMessage);
														setIsWayPointMessageModalOpen(true);
													}}
												>
													(Click to view full details)
												</span>
											</small>
										) : (
											<small className="ml-2 mt-2" style={{ color: "red" }}>
												{waypointStatusMessage}
											</small>
										)}
									</div>
								)}
							</div>
						</div> 	
					</MDBCol>
				)}
				{iswayPointMessageModalOpen && (
					<AbsModal
						isOpen={iswayPointMessageModalOpen}
						title="Failure Reason"
						onClose={setIsWayPointMessageModalOpen}
						close={() => setIsWayPointMessageModalOpen(false)}
					>
						<div style={{ padding: "10px", color: "red", wordBreak: "break-word" }}>
							{wayPointErrorMessage}
						</div>
					</AbsModal>
				)}
			</MDBRow>
			<div>
				<div className="mt-4">
					<CustomTable
						columnsData={VerificationColumns.filter((column) => !column.hidden)}
						renderTableData={associatedDocumentsData}
						customProps={{
							enableSort: false,
							enableToptoolbar: false,
							handleExportTable: false,
							showExportButton: false,
							showSwitch: true,
							// showSwitch: true,
							// renderSwitch: (<>

							// 	<Switch
							// 		links={["Yes", "No"]}
							// 		selected={selected}
							// 		onChange={(link) => handleChange(link)}
							// 	/>
							// </>)
						}}
					/>

					{isSelectFilesModalOpen && (
						<AbsModal isOpen={isSelectFilesModalOpen} title="Select Files" onClose={setIsSelectFilesModalOpen} close={onSelectFilesEvent}>
							<VerificationSelectFiles
								handleUploadClick={handleUploadClick}
								toggleModal={onSelectFilesEvent}
								toggleClose={onSelectFilesEvent}
								selectedFiles={selectedFiles}
								setSelectedFiles={setSelectedFiles}
							></VerificationSelectFiles>
						</AbsModal>
					)}

					{showModal && (
						<AbsModal isOpen={showModal} title="Reject" onClose={setShowModal} close={toggleClose}>
							<div className="pb-5">
								<form onSubmit={handleSubmit(onRejectReport)}>
									<div className="confirmation-modal-container p-3">
										<Label name="Please enter the reason for rejection" required bold />
										<Controller
											name="reason"
											control={control}
											rules={{
												required: "Reason is required",
											}}
											render={({ field }) => (
												<>
													<Input
														id="reason"
														type="text"
														onChange={field.onChange}
														value={field.value}
														autoFocus={false}
														className="name-input mt-2"
														placeholder="Enter your reason"
													/>
													{errors["reason"] && <p className="error">{errors["reason"].message}</p>}
												</>
											)}
										/>
										<div className="d-flex justify-content-end mt-5 mr-3">
											<button type="submit" className="mr-3 save-button" id="save-update-btn-portcode">
												Reject
											</button>
											<button
												id="cancel-btn-portcode"
												type="button"
												className="clear-button"
												onClick={() => {
													toggleClose();
													reset();
												}}
											>
												Cancel
											</button>
										</div>
									</div>
								</form>{" "}
							</div>
						</AbsModal>
					)}

					{showUpdateVerifierModal && (
						<div className="confirmation-modal-container">
							<Modal
								isOpen={showUpdateVerifierModal}
								modalHeader
								padding={"70px"}
								headerHeight={"50px"}
								showFooter
								onCloseClickListener={() => {
									setShowUpdateVerifierModal(false);
								}}
								footer={
									<div className="d-flex justify-content-end fixed-action-btns p-4">
										<Button
											className="modal-delete-btn"
											onClick={() => changeVerifierForReport()}
											primaryColor={COLORS.RED.DARK}
											primaryBackgroundColor={COLORS.RED.LIGHT}
										>
											Confirm
										</Button>
										<Button
											className="modal-cancel-btn"
											onClick={() => {
												setShowUpdateVerifierModal(false);
											}}
										>
											Cancel
										</Button>
									</div>
								}
							>
								<div>Access will be removed from the current verifier and granted to the selected verifier.</div>
							</Modal>
						</div>
					)}

					<div className="confirmation-modal-container">
						<Modal
							isOpen={confirmDelete}
							modalHeader
							padding={"70px"}
							headerHeight={"50px"}
							showFooter
							onCloseClickListener={() => {
								setConfirmDelete(false);
							}}
							footer={
								<div className="d-flex justify-content-end fixed-action-btns p-4">
									<Button
										className="modal-delete-btn"
										onClick={handleDeletingRecord}
										primaryColor={COLORS.RED.DARK}
										primaryBackgroundColor={COLORS.RED.LIGHT}
									>
										Delete
									</Button>
									<Button
										className="modal-cancel-btn"
										onClick={() => {
											setConfirmDelete(false);
										}}
									>
										Cancel
									</Button>
								</div>
							}
						>
							<div>Are you sure you want to delete this document?</div>
						</Modal>
					</div>
				</div>
			</div>
		</>
	);
};

export default Verification;
